<template>
    <v-dialog :value="dialog" width="800px">
        <v-card>
            <v-card-title
                    class="blue-grey darken-1 py-4 title"
            >
                Tribune {{key === null ? 'maken' : 'aanpassen'}}
            </v-card-title>
            <v-container grid-list-sm class="pa-4">
                <v-layout row wrap>
                    <v-flex xs12 align-center justify-space-between>
                        <v-layout align-center>
                            <v-text-field
                                    label="Omschrijving"
                                    v-model="description"
                            ></v-text-field>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12>
                        <v-select
                                label="Type"
                                :items="types"
                                v-model="type"
                        ></v-select>
                    </v-flex>
                    <v-flex xs12>
                        <v-select
                                label="Block"
                                :items="blocks"
                                v-model="block"
                        ></v-select>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                                label="Plaatsen"
                                v-model.number="places"
                                type="number"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field
                                label="Prijs kinderen"
                                v-model.number="price_kids"
                                type="number"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field
                                label="Prijs volwassenen"
                                v-model.number="price_adults"
                                type="number"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field
                                label="Prijs vriendenmatch"
                                v-model.number="price_friendly"
                                type="number"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field
                                label="Prijs Abonnement"
                                v-model.number="price_subscription"
                                type="number"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field
                                label="Prijs Gratis"
                                v-model.number="price_free"
                                type="number"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="closeDialog">Cancel</v-btn>
                <template v-if="key === null">
                    <v-btn flat dark @click="addTribune">Aanmaken</v-btn>
                </template>
                <template v-else>
                    <v-btn flat dark @click="editTribune">Aanpassingen opslaan</v-btn>
                </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { db } from "../../firebase";
export default {
  name: "TribuneDialog",
  props: {
    dialog: Boolean,
    selectedTribune: Object,
  },
  data: function() {
    return {
      blocks: [
        { value: "AA", text: "AA" },
        { value: "AB", text: "AB" },
        { value: "B-C-D-E", text: "B-C-D-E" },
        { value: "E", text: "E" },
        { value: "ERE", text: "ERE" },
        { value: "F", text: "F" },
        { value: "G", text: "G" },
        { value: "F-G-H-I", text: "F-G-H-I" }
      ],
      types: [
        { value: "stand", text: "Staan" },
        { value: "sit", text: "Zitplaatsen" }
      ],
      description: "",
      places: 0,
      block: "AA",
      type: "stand",
      key: null,
      price_kids: 0,
      price_adults: 0,
      price_friendly: 0,
      price_subscription: 0,
      price_free: 0
    };
  },
  watch: {
    selectedTribune: function(newVal) {
      if (newVal !== null) {
        this.key = newVal[".key"];
        this.description = newVal.description;
        this.type = newVal.type;
        this.block = newVal.block;
        this.places = newVal.places;
        this.price_kids = newVal.price_kids || 0;
        this.price_adults = newVal.price_adults || 0;
        this.price_friendly = newVal.price_friendly || 0;
        this.price_subscription = newVal.price_subscription || 0;
        this.price_free = newVal.price_free || 0;
      }
    }
  },
  firestore() {
    return {
      tribunes: db.collection("tribunes")
    };
  },
  methods: {
    resetData: function() {
      this.description = "";
      this.places = 0;
      this.block = "AA";
      this.type = "stand";
      this.key = null;
      this.price_kids = 0;
      this.price_adults = 0;
      this.price_friendly = 0;
      this.price_subscription = 0;
      this.price_free = 0;
    },
    closeDialog: function() {
      this.$emit("closeDialog", true);
      this.resetData();
    },
    addTribune: function() {
      db.collection("tribunes").add(this.buildTribuneData());
      this.closeDialog();
    },
    editTribune: function() {
      db.collection("tribunes")
        .doc(this.key)
        .set(this.buildTribuneData(true));
      this.closeDialog();
    },
    buildTribuneData(update = false) {
      const tribune = {
        description: this.description,
        type: this.type,
        block: this.block,
        places: this.places,
        price_kids: this.price_kids,
        price_adults: this.price_adults,
        price_friendly: this.price_friendly,
        price_subscription: this.price_subscription,
        price_free: this.price_free
      };
      if (!update) {
        tribune.timestamp = new Date();
      } else {
        tribune.updated = new Date();
      }

      return tribune;
    }
  }
};
</script>
